import Client from '../HttpClient';

const baseUrl = '/mole-api/device-app';

const listDevices = (merchantId, branchIds) => {
	return Client.get(`${baseUrl}/devices`, {
		merchantId,
		branchIds,
	});
};

const requestRemoteControl = (body) => {
	return Client.post(`${baseUrl}/remote-control/request`, body);
};

export default { listDevices, requestRemoteControl };
